import { useCallback } from 'react';

const useMobileAnnounceForAccessibility: () => (message: string) => void = () => {
  const announce = useCallback(() => {}, []);
  return announce;
};

export default useMobileAnnounceForAccessibility;
